import React from 'react';

import getUserFacingPolicies from 'auth/getUserFacingPolicies';
import {DataPolicy} from 'auth/PolicyConstants';
import * as PolicyDAO from 'auth/PolicyDAO';
import * as PolicyReduxActions from 'auth/PolicyReduxActions';
import DataConnector from 'connect/DataConnector';

import PoliciesListing from './PoliciesListing';

interface EnhancedProps {
  dataPolicies: Array<DataPolicy>;
}

class DataPoliciesListingConnector extends DataConnector<{}, EnhancedProps> {
  enhanceProps(): EnhancedProps {
    return {
      dataPolicies: getUserFacingPolicies(this.reduxState().models.policies.dataPolicies!),
    };
  }
}

function DataPoliciesListing(props: EnhancedProps): JSX.Element {
  return (
    <PoliciesListing
      policies={props.dataPolicies}
      getPolicyURL={PolicyDAO.getDataPolicyURL}
      deletePolicy={PolicyReduxActions.deleteDataPolicy}
      clonePolicy={PolicyReduxActions.cloneDataPolicy}
      reorderPolicies={PolicyReduxActions.reorderDataPolicies}
    />
  );
}

export default DataPoliciesListingConnector.connect(DataPoliciesListing);
